
import {Component, Vue, Watch, Ref} from "vue-property-decorator";
import { Socket } from "vue-socket.io-extended";
import app from "@/main";
import { ProgramPaths } from "@/enum/ProgramPaths";
import MenuBar from "@/components/page-components/MenuBar.vue";
import BildirimInfo from "@/components/infos/BildirimInfo.vue";
import UrunlerInfo from "@/components/infos/UrunlerInfo.vue";
import ImzaUyapConnectionInfo from "@/components/infos/ImzaUyapConnectionInfo.vue";
import UserInfoCard from "@/components/UserInfoCard.vue";
import AppFooter from "@/layout/AppFooter.vue";
import GuncellemelerInfo from "@/components/infos/GuncellemelerInfo.vue";
import KaynaklarInfo from "@/components/infos/KaynaklarInfo.vue";
import AnketInfo from "@/components/infos/AnketInfo.vue";
import SpinnerToast from "@/components/SpinnerToast.vue";
import LisansKisitBar from "@/components/LisansKisitBar.vue";
import RatingDialog from "@/components/dialogs/RatingDialog.vue";
import KatkiPaneliTanitimDialog from "@/components/dialogs/KatkiPaneliTanitimDialog.vue";
import RenewalButton from "@/components/renewal/RenewalButton.vue";
import RenewalModal from "@/components/renewal/RenewalModal.vue";
import RenewalCountdownBar from "@/components/renewal/RenewalCountdownBar.vue";
import DemoCountdownBar from "@/components/demo/DemoCountdownBar.vue";
import _swal from "sweetalert2";
import {KullaniciBilgileriCevap} from "@/plugins/uyap-plugin/uyap/KullaniciBilgileri";
import {
  kotaUyarisiKancasiniAyarla,
  devreKesiciKancasiniAyarla,
  durumMesajiKancasiniAyarla,
  DurumMesajiTipi
} from "@/plugins/uyap-plugin/BaglantiKurtarma";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {isletimSistemiBildirimi, uyariSesi} from "@/plugins/kritikUyari";
import OturumLimitiDialog from "@/components/dialogs/OturumLimitiDialog.vue";
import DevreKesiciDialog from "@/components/dialogs/DevreKesiciDialog.vue";

declare global {
  interface Window {
    pekiSettings: any;
  }
}

// "Daha Sonra Hatırlat" / kapatma sonrasi anketin tekrar gosterilmeyecegi sure (1 gun).
const RATING_SNOOZE_MS = 24 * 60 * 60 * 1000;

// Katki Paneli tanitimi kullanici basina YALNIZ BIR KEZ gosterilir; kapatildiginda
// (X / "Daha sonra" / ESC / dis tiklama / panele gitme) kalici olarak isaretlenir.
// Ileride yeni bir tanitim gerekirse surum artirilir: "...:v2".
const KATKI_PANELI_TANITIM_KEY = "katkiPaneliTanitim:v1";

@Component({
  computed: {
    ProgramPaths() {
      return ProgramPaths;
    },
  },
  components: {
    LisansKisitBar,
    AppFooter,
    UserInfoCard,
    ImzaUyapConnectionInfo,
    UrunlerInfo,
    BildirimInfo,
    MenuBar,
    GuncellemelerInfo,
    KaynaklarInfo,
    AnketInfo,

    SpinnerToast,
    RatingDialog,
    KatkiPaneliTanitimDialog,
    RenewalButton,
    RenewalModal,
    RenewalCountdownBar,
    DemoCountdownBar,
    OturumLimitiDialog,
    DevreKesiciDialog,
  }
})
export default class App extends Vue {
  drawer = null as boolean | null; // null olarak başlat
  isAnaMenu = false;
  ProgramPaths = ProgramPaths;
  showRatingDialog: boolean = false;
  showKatkiPaneliTanitim: boolean = false;
  oturumLimitiAcik: boolean = false;
  devreKesiciAcik: boolean = false;

  @Ref("spinnerToast") readonly spinnerToast!: SpinnerToast;

  created() {
    this.drawer = true;
    this.$store.commit('initAutoPlay');
    this.baglantiKurtarmaKancalariniBagla();
  }

  /**
   * uyap-plugin, kota dolu ve devre kesici uyarılarını kanca üzerinden bildiriyor;
   * kancayı kaydetmek uygulamanın işi (plugin store/DOM'a bağlanmasın diye).
   * kotaUyarisiKancasiniAyarla bugüne dek HİÇ çağrılmamıştı: DEV-2447'nin
   * anlattığı kota dialogu bu yüzden kullanıcıya hiç görünmedi.
   *
   * Bot gece de çalışıyor; kullanıcı ekrana bakmıyorken dialog tek başına yetmez,
   * bu yüzden işletim sistemi bildirimi ve ses de veriliyor (vue-imza-app ile aynı
   * davranış). Ses yalnızca uyarı ilk açıldığında çalar; her turda çalarsa
   * kanıksanır ve sinyal değerini yitirir.
   */
  private baglantiKurtarmaKancalariniBagla() {
    // Bu uygulamada durum mesajı toast olarak gösteriliyor; vue-imza-app aynı
    // kancayı UyapStatusCard'daki satır içi mesaja bağlıyor.
    durumMesajiKancasiniAyarla((tip: DurumMesajiTipi, metin: string) => {
      if (tip === "error") this.$toast.error(metin);
      else if (tip === "success") this.$toast.success(metin);
      else this.$toast.info(metin);
    });

    kotaUyarisiKancasiniAyarla(() => {
      if (this.oturumLimitiAcik) {
        return;
      }
      this.oturumLimitiAcik = true;
      isletimSistemiBildirimi(
          "UYAP oturum sınırına ulaşıldı",
          "Açık UYAP oturumlarınızı kapatıp yeniden bağlanın."
      );
      uyariSesi();
    });

    devreKesiciKancasiniAyarla(() => {
      if (this.devreKesiciAcik) {
        return;
      }
      // Botu durdur: kesici açıldıysa görev kuyruğunun devam etmesi ban riskini büyütür.
      this.$store.commit("setPlayerDurum", PlayerDurum.dur);
      this.devreKesiciAcik = true;
      isletimSistemiBildirimi(
          "İşlemler durduruldu",
          "UYAP bağlantısında tekrarlayan hata; ban riskine karşı işlemler durduruldu."
      );
      uyariSesi();
    });
  }

  mounted() {
    // Spinner service'e component referansını ver
    this.$nextTick(() => {
      if (this.$spinner && this.spinnerToast) {
        (this.$spinner as any).setComponent(this.spinnerToast);
      }
      // Sira onemli: tanitim bekliyorsa checkAndShowRating erken doner,
      // iki modal ust uste acilmaz.
      this.checkAndShowKatkiPaneliTanitim();
      this.checkAndShowRating();
    });
  }

  // Yenileme teklifi ve demo geri sayimi icin burada ISTEK ATILMAZ: ikisinin de
  // ham verisi /api/v1/ben yanitindaki `lisans_durum` alaniyla geliyor ve
  // sessionStorage'daki user ile birlikte duruyor. Bu yuzden sayfa yenilemesi
  // sifir istek eder; hesap renewalOfferFor / demoStatusFor getter'larinda yapilir.
  @Watch("userId")
  onUserIdChangeForRenewal(id: number | undefined) {
    if (id) {
      // mounted sirasinda henuz login olunmamis olabilir; tanitim burada yakalanir.
      this.checkAndShowKatkiPaneliTanitim();
    }
  }

  get isEicrapro() {
    return this.$route.path.includes(ProgramPaths.eicrapro);
  }

  get ratingMode() {
    return this.isEicrapro ? 'beta-screen' : 'general';
  }

  get pendingTakipHazirlaRatingDialog(): boolean {
    return this.$store.getters['takipHazirla/pendingTakipHazirlaRatingDialog'];
  }

  checkAndShowRating() {
    if (this.isEicrapro) {
      return;
    }
    // Katki Paneli tanitimi acik ya da hala sirada ise anketi bekletiriz;
    // ilk giriste kullaniciyi ust uste iki modalle karsilamayalim.
    if (this.showKatkiPaneliTanitim || !this.isKatkiPaneliTanitimSeen()) {
      return;
    }
    // Kullanici "Daha Sonra Hatirlat" / X dediyse, sure dolana dek tekrar acma.
    if (this.isRatingSnoozed('general')) {
      return;
    }
    if (this.userId) {
      this.showRatingDialog = true;
    }
  }

  /** Tanitim kaydi kullanici bazli tutulur; ayni bilgisayardaki her hesap bir kez gorur. */
  get katkiPaneliTanitimKey(): string {
    const userId = this.$store.state.user.id;
    return `${KATKI_PANELI_TANITIM_KEY}:${userId || 'anonim'}`;
  }

  isKatkiPaneliTanitimSeen(): boolean {
    try {
      return localStorage.getItem(this.katkiPaneliTanitimKey) === '1';
    } catch (e) {
      // localStorage kapaliysa "gorulmus" say: her acilista tekrar gostermekten iyidir.
      return true;
    }
  }

  checkAndShowKatkiPaneliTanitim() {
    if (!this.userId || this.isKatkiPaneliTanitimSeen()) {
      return;
    }
    this.showKatkiPaneliTanitim = true;
  }

  /**
   * Tanitim hangi yolla kapanirsa kapansin (X / "Daha sonra" / ESC / dis tiklama /
   * panele gitme) bir kez gorulmus sayilir ve sirada bekleyen anket serbest kalir.
   */
  @Watch("showKatkiPaneliTanitim")
  onKatkiPaneliTanitimChange(val: boolean) {
    if (val) {
      return;
    }
    try {
      localStorage.setItem(this.katkiPaneliTanitimKey, '1');
    } catch (e) {
      console.error('Katkı Paneli tanıtımı kaydedilemedi:', e);
    }
    this.$nextTick(() => this.checkAndShowRating());
  }

  // Toggle metodu ekle
  toggleDrawer() {
    this.drawer = !this.drawer;
  }

  // MenuBar'dan gelen close-drawer event'ini handle et
  closeDrawer() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.drawer = false;
    }
  }

  // Route'a göre drawer durumunu ayarlayan method
  setDrawerStateByRoute() {
    const isMainRoute =
        this.$route.path === ProgramPaths.ofispro ||
        this.$route.path === ProgramPaths.icrapro ||
        this.$route.path === ProgramPaths.eicrapro;

    if (isMainRoute) {
      this.drawer = true;
    }
  }

  get userId() {
    let id = this.$store.state.user.id;
    return id;
  }

  get showDevWarn() {
    let isEicrapro = this.$route.path.includes(ProgramPaths.eicrapro);
    let isTestSite =
        location.hostname.split(".")[0] == "cloudtest" ||
        location.hostname.split(".")[0] == "cloudbeta" ||
        location.hostname.split(".")[0] == "localhost";
    return isEicrapro && isTestSite && this.$store.getters.isEicraproDevMode;
  }

  toggleDevMode(): void {
    const nextState = !this.$store.state.eicraproDevMode;
    this.$store.commit("setEicraproDevMode", nextState);
    this.$store.dispatch("checkUyapSession");
  }

  @Socket("player")
  onPlayer(player: any) {
    this.$store.commit("setPlayerDurum", Number(player));
  }

  @Socket("updateTasks")
  onUpdateTask() {
    this.$store.dispatch("updateTasks");
  }

  @Socket("imzaMessage")
  async onImzaMessage(message: any) {
    console.log("imzaMessage Fired", message);
    await _swal.fire(message);
  }

  @Socket("uyapAvukatBilgileri")
  onAvukatBilgileriChange(data: {uyapAvukatBilgileri: KullaniciBilgileriCevap, uyapAvukatBakiye: string, uyapSorguBakiye: string}) {
    this.$store.commit("setUyapAvukatBilgileri", data.uyapAvukatBilgileri);
    this.$store.commit("setUyapAvukatBakiye", data.uyapAvukatBakiye);
    this.$store.commit("setUyapSorguBakiye", data.uyapSorguBakiye);
  }

  @Socket("refreshConnection")
  onRefreshConnection() {
    console.log("Socket refreshConnection triggered");
    this.$store.dispatch("checkUyapSession");
  }

  @Socket("notification")
  onNotification(notification: { message: string, seconds: number }) {
    this.$spinner.message(notification.message,notification.seconds);
  }

  @Socket("uyapconnection")
  async onUyapConnection(data: { connected: boolean; JSESSIONID: string }) {
    console.log("soket cevap uyap bağlı", data.connected ? "EVET" : "HAYIR");
    if (data) {
      this.$store.commit("setUyapConnection", data.connected);
      if (
          !(
              window.localStorage.hasOwnProperty("JSESSIONID") &&
              window.localStorage.getItem("JSESSIONID") == data.JSESSIONID
          )
      ) {
        localStorage.setItem("JSESSIONID", data.JSESSIONID);
        // TODO: port değişken yapılacak
        const cookieSetUrl =
            "https://imza.eicrapro.com:6099" +
            "/cookie?" +
            data.JSESSIONID +
            ";SameSite=None;Secure";
        await app.$uyap.SetCookie().run({ url: cookieSetUrl });
      }
    }
  }

  @Watch("$route")
  onPathnameChange() {
    if (
        this.$route.path == ProgramPaths.ofispro ||
        this.$route.path == ProgramPaths.icrapro ||
        this.$route.path == ProgramPaths.eicrapro
    ) {
      this.isAnaMenu = true;
      this.drawer = true; // Ana menüde drawer'ı aç
    } else {
      this.isAnaMenu = false;
      // Mobilde route değiştiğinde drawer'ı kapat
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false;
      }
    }

    // Anket kontrolü (Route değiştiğinde de kontrol et)
    this.checkAndShowRating();
  }

  @Watch("$socket.connected")
  onSocketConnectionChange() {
    console.log("Socket connected WATCH");
    this.$nextTick(() => {
      this.$store.dispatch("checkUyapSession");
    });
  }

  @Watch("pendingTakipHazirlaRatingDialog")
  onPendingTakipHazirlaRatingChange(pending: boolean) {
    if (this.showKatkiPaneliTanitim) {
      return;
    }
    if (pending && this.isEicrapro && this.userId && !this.isRatingSnoozed('beta-screen')) {
      this.showRatingDialog = true;
    }
  }

  @Watch("showRatingDialog")
  onShowRatingDialogChange(val: boolean) {
    if (!val) {
      this.$store.commit('takipHazirla/CLEAR_PENDING_TAKIP_HAZIRLA_RATING');
    }
  }

  onRatingSave(data: { rating: number, comment: string }) {
    console.log('User Rating:', data);
    this.$toast.success('Görüşleriniz için teşekkür ederiz!');
  }

  /**
   * Anket "Daha Sonra Hatirlat" veya capraz (X) ile kapatildiginda tetiklenir.
   * Ilgili modu 1 gun boyunca "ertelendi" olarak isaretler; bu sure dolana kadar
   * ekran degisimlerinde anket tekrar acilmaz.
   */
  onRatingRemindLater(mode: string) {
    this.snoozeRating(mode || this.ratingMode);
  }

  ratingSnoozeKey(mode: string): string {
    return `ratingDialogSnoozeUntil:${mode}`;
  }

  isRatingSnoozed(mode: string): boolean {
    try {
      const raw = localStorage.getItem(this.ratingSnoozeKey(mode));
      if (!raw) {
        return false;
      }
      const until = Number(raw);
      return Number.isFinite(until) && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  snoozeRating(mode: string): void {
    try {
      const until = Date.now() + RATING_SNOOZE_MS;
      localStorage.setItem(this.ratingSnoozeKey(mode), String(until));
    } catch (e) {
      console.error('Anket hatirlatma suresi kaydedilemedi:', e);
    }
  }
}
